import { headerTranslations } from './header';
import { authTranslations } from './auth';
import { companyHeaderTranslations } from './companyHeader'; 
import { userNavTranslations } from './userNav';
import { legalTranslations } from './legal'; 
import { shopTranslations } from './shop';
import { friendsTranslations } from './friends';
import { sidebarTranslations } from './sidebar';
import { statsTranslations } from './stats';
import { depositModalTranslations } from './depositModal';
import { privacyTranslations } from './privacy';
import { contactsTranslations } from './contacts';
import { purchaseTranslations } from './purchase';
import { clanTranslations } from './clans';


export type Locale = 'ru' | 'en'; 

export const SUPPORTED_LANGUAGES: { code: Locale; label: string }[] = [
  { code: 'ru', label: 'Русский' },
  { code: 'en', label: 'English' },
]; 

export const dictionaries = {
  ru: { 
    header: headerTranslations.ru,
    shop: shopTranslations.ru,
    purchase: purchaseTranslations.ru,
    friends: friendsTranslations.ru,
    stats: statsTranslations.ru,
    contacts: contactsTranslations.ru,
    clans: clanTranslations.ru,
    depositModal: depositModalTranslations.ru,
    sidebar: sidebarTranslations.ru,
    auth: authTranslations.ru,
    privacy: privacyTranslations.ru,

    userNav: userNavTranslations.ru,
    companyHeader: companyHeaderTranslations.ru,
    legal: legalTranslations.ru,
    seo: {
      siteName: "RpLands",
      title: "RpLands Multiverse — Приватный Minecraft Сервер | Политика и RP",
      description: "Уникальный политический сервер Майнкрафт 26.1+. Строй города, создавай государства, принимай законы. Голосовой чат (Plasmo Voice), экономика, суды. Играй с ПК (Java) и телефона (Bedrock) без вайпов и приватов.",
      keywords: ['Minecraft', 'Майнкрафт', 'Сервер Майнкрафт', 'Minecraft Server', 'майнкрафт сервер', 'майнкрафт сервера', 'RP', 'Roleplay', 'Ролеплей', 'РП', 'РП сервер', 'рп сервер', 'сервер рп', 'RpLands', 'rplands', 'Royolands', 'royyo', 'royo', 'РПлендс', 'ройолендс', 'RpLands Multiverse', 'minecraft rplands', 'rplands minecraft server', 'rplands server', 'игры royolands', 'сервера royolands', 'minecraft minigames', 'майнкрафт миниигры', 'rplands java', 'rplands bedrock', 'рплендс играть', 'майнкрафт играть', 'ролеплей сервера', 'ролеплей майнкрафт', 'Политика', 'Политический сервер', 'Выживание', 'Survival', 'Vanilla', 'Ванилла', 'Без вайпов', 'Без приватов', 'Приватный сервер', 'приватный майнкрафт сервер', 'приватный Minecraft сервер', 'приватный сервер в майнкрафте', 'Голосовой чат', 'Города', 'Java', 'Bedrock', 'Кроссплей', 'играть в майнкрафт', 'играть в Minecraft', 'играть майнкрафт', 'майнкрафт с друзьями', 'майнкрафт на сервере', 'майнкрафт сервер лучший', 'лучший приватный сервер майнкрафт', 'играть на приватных майнкрафт серверах', 'играть на приватном майнкрафт сервере онлайн', 'играть онлайн в майнкрафт', 'что такое майнкрафт сервера', 'майнкрафт сервера лучшие', 'самые лучшие майнкрафт сервера', 'приватные сервера играть онлайн', 'что такое приватные сервера', 'приватные сервера в майнкрафте', 'майнкрафт приватные', 'лучшие сервера в России', 'сервера России в майнкрафт', 'майнкрафт сервера в России', 'RpLands сайт'],
      ogTitle: "RpLands — Живой мир Minecraft с Ролеплеем",
      ogDescription: "Вступай в эпоху дипломатии и войн. Реальная экономика, голосовой чат и кроссплатформенная игра (Java & Bedrock). Начни свою историю!",
      ogImageAlt: "RpLands - Игроки строят город",
      twitterTitle: "RpLands — Политический Minecraft Сервер",
      twitterDescription: "Строй, торгуй, управляй. Сервер без вайпов с голосовым чатом.",
      schemaDescription: "Политический Minecraft сервер с элементами RP, голосовым чатом и экономикой.",
      schemaOffer: "Бесплатный доступ к серверу (Free-to-play)",
      currency: "RUB"
    },
  profile: {
    title: "Личный кабинет",
    loading: "Загрузка профиля...",
    accessDenied: "Доступ запрещен",
    loginRequired: "Войдите в аккаунт, чтобы просмотреть свой профиль.",
    dashboard: "Личный кабинет",
    viewProfile: "Профиль",
    tabs: {
      overview: "Обзор",
      appearance: "Внешний вид",
      account: "Аккаунт"
     },
    balanceTitle: "Ваш баланс",
    crystals: "Кристаллов",
    active: "Активен",
    missing: "Отсутствует",
    projectAccess: "Доступ к проекту",
    buyPass: "Купить проходку",
    checking: "Проверка...",
    checkWhitelist: "Проверить вайтлист",
    mute: "Мут",
    accountStatus: "Статус аккаунта",
    hasRestrictions: "Имеются ограничения",
    noViolations: "Без нарушений",
    moreDetails: "Подробнее",
    aboutMe: "О себе",
    checkError: "Ошибка проверки",
    networkError: "Ошибка сети"
   },
    map: {
      title: "Онлайн Карта",
      description: "Следите за миром сервера, перемещениями игроков и границами городов в реальном времени.",
      synchronized: "Синхронизировано",
      syncTitle: "Синхронизация координат",
      syncDesc: "Доступ к интерактивной карте будет открыт после окончания отсчета. Подготовьтесь к исследованию!",
      days: "Дней",
      hours: "Часов",
      minutes: "Минут",
      seconds: "Секунд"
    },
    footer: {
      networkDesc: "Сервер является частью сети серверов RpLands",
      legalName: "ИП ВОЕВОДИН НИКИТА АЛЕКСАНДРОВИЧ",
      legalOgrnip: "ОГРНИП 326237500383373",
      legalInn: "ИНН 751903831760",
      projectHeading: "Проект",
      navNews: "Новости",
      navStats: "Статус серверов",
      navWiki: "База знаний",
      mojangCurrency: "Внутриигровая валюта и товары не связаны с Mojang",
      navMap: "Онлайн карта",
      helpHeading: "Помощь",
      navSupport: "Поддержка",
      navRules: "Правила",
      navShop: "Магазин",
      langName: "Русский",
      notAffiliated: "Не связано с Mojang AB.",
      privacyPolicy: "Политика конфиденциальности",
      termsOfService: "Пользовательское соглашение",
      paymentText: "ПРИНИМАЕМ К ОПЛАТЕ:",
      teamProject: "Проект команды ROYOLANDS ©"
    },
    landing: {
      meta: {
        title: 'RpLands — Ванильные сервера Minecraft',
        description: 'Выживание, Политика, Ролеплей. Города, альянсы, законы и настоящая жизнь.',
      },
      hero: {
        title1: "НОВЫЙ СТАНДАРТ",
        title2: "ДЛЯ",
        words: ["РОЛЕПЛЕЯ", "ТВОРЧЕСТВА", "СВОБОДЫ"],
        subscribe: "Подпишись",
        subtitle: "Ванильный сервер для тех, кто ценит",
        subtitleHighlight: "РП и свободу",
        copied: "IP скопирован!",
        playBtn: "Играть"
      },
      about: {
        heading1: "Никакой магии.",
        heading2: "Только чистый ванилла-рп.",
        desc: "Мы сохраняем оригинальный дух игры, добавляя лишь необходимые инструменты для создания качественного ролевого процесса.",
        societyTag: "Общество",
        societyTitle: "Города и Нации",
        societyDesc: "Объединяйтесь с друзьями, стройте уникальные поселения и пишите свою историю. Здесь нет приватов - только доверие и законы.",
        econTitle: "Живая Экономика",
        econDesc: "Только свободный рынок, торговые лавки игроков и банковская система на алмазной основе.",
        lawTitle: "Суд и Право",
        lawDesc: "Конфликты решаются не силой, а в суде. Выбирайте судей, нанимайте адвокатов и отстаивайте свою правду в рамках закона.",
        voiceTitle: "Войсчат и общение",
        voiceDesc: "Встроенный Plasmo Voice позволяет слышать собеседника в зависимости от расстояния и окружения, делая игру по-настоящему живой."
      },
      features: {
        optTag: "ОПТИМИЗАЦИЯ",
        optTitle: "TPS",
        optDesc: "Мощное ядро и тонкая оптимизация серверной части позволяют играть комфортно и без лагов.",
        optItems: ['Стабильные TPS', 'Асинхронные вычисления', 'Никаких фризов'],
        srvTag: "СЕРВИСЫ",
        srvTitle: "Личный кабинет",
        srvDesc: "Полный контроль над персонажем вне игры. Переводи валюту, оплачивай штрафы, настроивай профиль, создавай кланы и следи за рынком онлайн.",
        srvItems: ['История транзакций', 'Управление кланами', 'Настройка аккаунта'],
        msgTag: "ОБЩЕНИЕ",
        msgTitle: "Мессенджер",
        msgDesc: "Не пропускай важные события, даже если вне игры. Общайся с друзьями в любое время, демонстрируй экран и создавай гильдии. Полная синхронизация с сервером.",
        msgItems: ['Синхронизация с Minecraft', 'Безопасное шифрование', 'Приложение на Windows и Linux'],
      },
      carousel: {
        heading: "Внимание к деталям",
        subheading: "Маленькие функции, которые делают игру комфортной",
        mapTitle: "Интерактивная карта",
        mapDesc: "Полноценный взгляд на сервер онлайн.",
        mapLink: "Открыть карту",
        charTitle: "РП Персонажи",
        charDesc: "Станьте кем угодно не выходя с сервера. Создавайте персонажей, настраивайте им скин и имя прямо в игре.",
        charLink: "Подробнее",
        emoteTitle: "Эмоции и жесты",
        emoteDesc: "Полная поддержка любимых эмодзи прямо на сервере. Используйте сотни уникальных анимаций для лучшего погружения.",
        emoteLink: "Подробнее",
        armorTitle: "Стойки для брони",
        armorDesc: "Создавайте уникальные декорации для ваших построек. Достаточно кликнуть кремнием по стойке для брони.",
        armorLink: "Подробнее",
        chatTitle: "Разделение чата",
        chatDesc: "Используйте локальный чат, чтобы Ваши сообщения были видны только игрокам поблизости, не перегружая глобальный.",
      },
      pricing: {
        title: "Начни свою историю",
        subtitle: "Без креатива у админов и рисованных ресурсов.",
        formTitle: "Анкета",
        formFeatures: ['Полный доступ к серверу', 'Поддержка Java и Bedrock', 'Личный кабинет'],
        formBtn: "Пройти анкету",
        passTitle: "Проходка",
        passSub: "Навсегда",
        passFeatures: ['RP PREMIUM на неделю', 'Приоритет в очереди', 'Роль в Discord'],
        passBtn: "Приобрести"
      },
      faq: {
        title: "Частые вопросы",
        askDiscord: "Задать вопрос в Discord",
        items: [
          { q: "Нужна лицензия Minecraft?", a: "Да, для игры на сервере требуется официальная копия игры Minecraft." },
          { q: "Как зайти с телефона?", a: "Мы официально поддерживаем Bedrock Edition. IP и порт для подключения такие же, как для ПК версии." },
          { q: "Есть ли вайпы?", a: "Глобальные вайпы происходят только при смене сезонов (раз в 6-12 месяцев). Ваши постройки сохраняются долго." },
          { q: "Что если меня загриферят?", a: "У нас стоит плагин CoreProtect. Любое действие (блок, сундук) можно откатить, а грифер будет забанен навсегда." }
        ]
      },
      video: {
        title1: "Мы и наше сообщество",
        title2: "создаёт контент",
        marquee1: "Анимации",
        marquee2: "по серверу",
        modalTitle: "Наши анимации"
      },
      join: {
        title: "Присоединяйся"
      },
      modal: {
        title: "Подача заявки",
        webTitle: "Сайт",
        webDesc: "Подайте анкету через сайт",
        desc: "Выберите удобную для вас платформу. Наш бот проведет вас через все этапы заполнения анкеты.",
        tgTitle: "Telegram Bot",
        tgDesc: "Быстро и удобно прямо в мессенджере",
        dsTitle: "Discord",
        dsDesc: "Через тикет-систему на нашем сервере",
        wait: "Среднее время ожидания — ",
        waitTime: "40 минут"
      }
    }
  },
  en: {
    header: headerTranslations.en,
    auth: authTranslations.en,
    userNav: userNavTranslations.en,
    friends: friendsTranslations.en,
    clans: clanTranslations.en,
    privacy: privacyTranslations.en,
    purchase: purchaseTranslations.en,
    contacts: contactsTranslations.en,

    stats: statsTranslations.en,
    sidebar: sidebarTranslations.en,
    depositModal: depositModalTranslations.en,
    shop: shopTranslations.en,
    legal: legalTranslations.en,
    companyHeader: companyHeaderTranslations.en,
    seo: {
      siteName: "RpLands ",
      title: "RpLands Multiverse — Private Minecraft Server | Politics & RP",
      description: "Unique political Minecraft server 26.1+. Build cities, create nations, pass laws. Proximity voice chat, economy, courts. Play on PC (Java) and Mobile (Bedrock). No wipes, no claims.",
      keywords: [
  'Minecraft',
  'Minecraft Server',
  'RP',
  'Roleplay',
  'RpLands',
  'Royolands',
  'RP Server',
  'Minecraft RP Server',
  'Minecraft Roleplay',
  'Minecraft Roleplay Server',
  'Minecraft Server',
  'Minecraft Servers',
  'RpLands Minecraft',
  'RpLands Minecraft Server',
  'RpLands Server',
  'Royolands Games',
  'Royolands Servers',
  'RpLands Multiverse',
  'RpLands',
  'Royo',
  'Royyo',
  'Minecraft Minigames',
  'RpLands Java',
  'RpLands Bedrock',
  'Play RpLands',
  'Minecraft Gameplay',
  'Minecraft Roleplay Servers',
  'Roleplay Minecraft',
  'Political Minecraft Server',
  'Politics',
  'Political Server',
  'Survival',
  'Vanilla',
  'No Resets',
  'No Wipes',
  'No Land Claims',
  'Private Server',
  'Voice Chat',
  'Cities',
  'Java Edition',
  'Bedrock Edition',
  'Java Bedrock Crossplay',
  'Crossplay'
],

      ogTitle: "RpLands — A Living Minecraft World with Politics",
      ogDescription: "Enter the era of diplomacy and wars. Real economy, voice chat, and cross-platform play (Java & Bedrock). Start your story today!",
      ogImageAlt: "RpLands Server - Players building a city",
      twitterTitle: "RpLands — Political Minecraft Server",
      twitterDescription: "Build, trade, and govern. No-wipe server with proximity voice chat.",
      schemaDescription: "Political Minecraft server with RP elements, voice chat, and player-driven economy.",
      schemaOffer: "Free access to the server (Free-to-play)",
      currency: "USD"
     },
  profile: {
    title: "Personal account",
    loading: "Loading profile...",
    accessDenied: "Access Denied",
    loginRequired: "Please log in to view your profile.",
    dashboard: "Dashboard",
    viewProfile: "Profile",
    tabs: {
      overview: "Overview",
      appearance: "Appearance",
      account: "Account"
    },
    balanceTitle: "Your Balance",
    crystals: "Crystals",
    active: "Active",
    missing: "Missing",
    projectAccess: "Project Access",
    buyPass: "Buy Pass",
    checking: "Checking...",
    checkWhitelist: "Check Whitelist",
    mute: "Muted",
    accountStatus: "Account Status",
    hasRestrictions: "Has Restrictions",
    noViolations: "No Violations",
    moreDetails: "More Details",
    aboutMe: "About Me",
    checkError: "Verification Error",
    networkError: "Network Error"
  },
    map: {
      title: "Online Map",
      description: "Track the server world, player movements, and city borders in real time.",
      synchronized: "Synchronized",
      syncTitle: "Synchronizing Coordinates",
      syncDesc: "Access to the interactive map will be opened after the countdown ends. Get ready to explore!",
      days: "Days",
      hours: "Hours",
      minutes: "Minutes", 
      seconds: "Seconds"
    },
    footer: {
      networkDesc: "The server is part of the RpLands server network",
      legalName: "IE VOEVODIN NIKITA ALEKSANDROVICH",
      mojangCurrency: "In-game currency and items are not affiliated with Mojang",
      legalOgrnip: "OGRNIP 326237500383373",
      legalInn: "TIN 751903831760",
      projectHeading: "Project",
      navNews: "News",
      navStats: "Server Status",
      navWiki: "Knowledge Base",
      navMap: "Online Map",
      helpHeading: "Help",
      navSupport: "Support",
      navRules: "Rules",
      navShop: "Store",
      langName: "English",
      notAffiliated: "Not affiliated with Mojang AB.",
      privacyPolicy: "Privacy Policy",
      termsOfService: "Terms of Service",
      paymentText: "ACCEPTED PAYMENT METHODS:",
      teamProject: "A project by the ROYOLANDS team ©"
    },
    landing: {
      meta: {
        title: 'RpLands — Vanilla Minecraft Servers',
        description: 'Survival, Politics, Roleplay. Towns, alliances, laws, and real life.',
      },
      hero: {
        title1: "THE NEW STANDARD",
        title2: "FOR",
        words: ["ROLEPLAY", "CREATIVITY", "FREEDOM"],
        subscribe: "Follow us",
        subtitle: "A vanilla server for those who value",
        subtitleHighlight: "RP & Freedom",
        copied: "IP Copied!",
        playBtn: "Play"
      },
      about: {
        heading1: "No magic.",
        heading2: "Pure vanilla RP.",
        desc: "We preserve the original spirit of the game, adding only the necessary tools to create a high-quality roleplay experience.",
        societyTag: "Society",
        societyTitle: "Cities & Nations",
        societyDesc: "Unite with friends, build unique settlements, and write your own history. No land claims—only trust and laws.",
        econTitle: "Live Economy",
        econDesc: "A purely free market, player-owned shops, and a diamond-backed banking system.",
        lawTitle: "Justice & Law",
        lawDesc: "Conflicts are resolved in court, not by force. Elect judges, hire lawyers, and defend your truth within the law.",
        voiceTitle: "Voice Chat",
        voiceDesc: "Built-in Plasmo Voice lets you hear others based on distance and environment, making the game truly alive."
      },
      features: {
        optTag: "OPTIMIZATION",
        optTitle: "TPS",
        optDesc: "A powerful core and deep server-side optimization allow you to play comfortably without lag.",
        optItems: ['Stable TPS', 'Asynchronous computing', 'Zero freezes'],
        srvTag: "SERVICES",
        srvTitle: "Dashboard",
        srvDesc: "Full control over your character outside the game. Transfer currency, pay fines, manage your profile and clans.",
        srvItems: ['Transaction history', 'Clan management', 'Account settings'],
        msgTag: "COMMUNICATION",
        msgTitle: "Messenger",
        msgDesc: "Don't miss important events, even offline. Chat with friends anytime, share screens, and create guilds.",
        msgItems: ['Minecraft sync', 'Secure encryption', 'Windows & Linux app'],
      },
      carousel: {
        heading: "Attention to Detail",
        subheading: "Small features that make the game comfortable",
        mapTitle: "Interactive Map",
        mapDesc: "A complete live view of the server.",
        mapLink: "Open Map",
        charTitle: "RP Characters",
        charDesc: "Become anyone without leaving the server. Create characters and customize skins in-game.",
        charLink: "Learn More",
        emoteTitle: "Emotes & Gestures",
        emoteDesc: "Full support for your favorite emotes directly on the server. Use hundreds of unique animations.",
        emoteLink: "Learn More",
        armorTitle: "Armor Stands",
        armorDesc: "Create unique decorations for your builds. Just click on an armor stand with flint.",
        armorLink: "Learn More",
        chatTitle: "Chat Separation",
        chatDesc: "Use local chat so your messages are only seen by nearby players, keeping global chat clean.",
      },
      pricing: {
        title: "Start Your Story",
        subtitle: "No admin abuse, no fake items.",
        formTitle: "Application",
        formFeatures: ['Full server access', 'Java & Bedrock support', 'Web Dashboard'],
        formBtn: "Apply Now",
        passTitle: "Pass",
        passSub: "Lifetime",
        passFeatures: ['RP PREMIUM for a week', 'Queue priority', 'Discord Role'],
        passBtn: "Purchase"
      },
      faq: {
        title: "Frequently Asked Questions",
        askDiscord: "Ask a question in Discord",
        items: [
          { q: "Do I need a Minecraft license?", a: "Yes, a Minecraft license is required to play on the server." },
          { q: "Can I play from my phone?", a: "Yes, we officially support Bedrock Edition. The IP and port are the same as the PC version." },
          { q: "Are there wipes?", a: "Global wipes only happen when seasons change (every 6-12 months). Your builds are saved for a long time." },
          { q: "What if I get griefed?", a: "We use CoreProtect. Any action (blocks, chests) can be rolled back, and the griefer will be permanently banned." }
        ]
      },
      video: {
        title1: "We and our community",
        title2: "create content",
        marquee1: "Animations",
        marquee2: "on the server",
        modalTitle: "Our Animations"
      },
      join: {
        title: "Join Us"
      },
      modal: {
        title: "Submit Application",
        webTitle: "Web",
        webDesc: "Fill out the application via the website",
        desc: "Choose a convenient platform. Our bot will guide you through all the steps.",
        tgTitle: "Telegram Bot",
        tgDesc: "Fast and easy right in the messenger",
        dsTitle: "Discord",
        dsDesc: "Via the ticket system on our server",
        wait: "Average wait time — ",
        waitTime: "40 minutes"
      }
    }
  }
};

export type Locale = keyof typeof dictionaries;

export const languagesConfig: Record<Locale, { code: Locale; name: string }> = {
  ru: { code: 'ru', name: 'Русский' },
  en: { code: 'en', name: 'English' },
};

